import * as v from "valibot";

import { rpcContract } from "../rpc";

export interface BulkImportCreatorInput {
  knownLinksOrNames: string[];
}

export interface BulkImportCreatorSuccessResult {
  status: "success";
  input: string[];
  profile: {
    handle: string;
    socialLinks: string[];
    avatarImg?: string;
    bio: string;
  };
}

export interface BulkImportCreatorFailedResult {
  status: "failed";
  input: string[];
  reason: string;
}

export type BulkImportCreatorResult = BulkImportCreatorSuccessResult | BulkImportCreatorFailedResult;

export const bulkImportCreatorsRpcContract = rpcContract({
  name: "bulkImportCreators",
  paramsSchema: v.object({
    creators: v.array(
      v.object({
        knownLinksOrNames: v.array(v.string()),
      }),
    ),
  }),
  resultSchema: v.undefined(),
});

export type BulkImportCreatorsParams = v.InferOutput<(typeof bulkImportCreatorsRpcContract)["paramsSchema"]>;
export type BulkImportCreatorsResult = v.InferOutput<(typeof bulkImportCreatorsRpcContract)["resultSchema"]>;
